export const USER_SIGNIN_REQUEST ="USER_SIGNIN_REQUEST";
export const USER_SIGNIN_SUCCESS ="USER_SIGNIN_SUCCESS";
export const USER_SIGNIN_FAIL ="USER_SIGNIN_FAIL";
export const USER_SIGNOUT ="USER_SIGNOUT";
export const USER_REFRESH_REQUEST ="USER_REFRESH_REQUEST";
export const USER_REFRESH_SUCCESS ="USER_REFRESH_SUCCESS";
export const USER_REFRESH_FAIL ="USER_REFRESH_FAIL";